import * as constants from '../constants';

const initialState = {
    data: [],
    item: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getPesticideChemicalClasses.success: {
            return {
                ...state, data: action.payload.results
            };
        }

        case constants.getPesticideChemicalClassesItem.success: {
            return {
                ...state, item: { ...action.payload }
            };
        }

        default:
            return state;
    }
}
